var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"8","height":"2","viewBox":"0 0 8 2","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"8","width":"2","height":"8","transform":"rotate(90 8 0)","fill":"#1F2129"}})])}
var staticRenderFns = []

export { render, staticRenderFns }